import { METHOD_STEPS } from "@/data/lakaData";

const Method = () => (
  <section
    data-testid="method-section"
    className="py-24 md:py-32"
    style={{ background: "#FBF6F2" }}
  >
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <div className="grid lg:grid-cols-12 gap-10 lg:gap-16">
        <div className="lg:col-span-4">
          <span className="laka-eyebrow">El método</span>
          <h2 className="mt-4 font-serif-laka text-4xl md:text-5xl lg:text-[3.2rem] font-light leading-[1.05] text-[#1A1A1A]">
            El método <span className="italic text-[#D6B36A]">LAKA</span>
          </h2>
          <p className="mt-6 text-sm md:text-base text-[#1A1A1A]/70 leading-relaxed font-light">
            Cada persona necesita un cuidado diferente. Por eso en LAKA CLUB
            BEAUTY trabajamos desde la personalización, la tecnología y el
            seguimiento.
          </p>
        </div>

        <div className="lg:col-span-8">
          <ol className="space-y-8">
            {METHOD_STEPS.map((s, i) => (
              <li
                key={s.n}
                data-testid={`method-step-${i}`}
                className="grid grid-cols-[auto_1fr] gap-6 md:gap-8 items-start pb-8 border-b border-[#D6B36A]/25 last:border-0"
              >
                <div className="font-serif-laka text-4xl md:text-5xl text-[#D6B36A] leading-none w-14">
                  {s.n}
                </div>
                <div>
                  <h3 className="font-serif-laka text-2xl md:text-3xl text-[#1A1A1A] leading-tight">
                    {s.title}
                  </h3>
                  <p className="mt-2 text-sm md:text-base text-[#1A1A1A]/70 leading-relaxed font-light">
                    {s.text}
                  </p>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </div>
  </section>
);

export default Method;
